import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useStoresSettlementTimezone = defineStore(
  'storesSettlementTimezone',
  () => {
    const settlement = ref<string>('00:00')
    // 判斷「現在是否已過結帳點」要用店家時區，用瀏覽器時區會差一天（OP#2730）。
    // 來源是 GetStoreTimeZone 的 timeZone 欄位
    const timeZoneId = ref<string>('')

    const getSettlement = () => {
      return settlement.value
    }

    const getSettlementTimeZone = () => {
      return timeZoneId.value
    }

    /**
     * @param zoneId 店家時區（IANA）。首頁只算得出多數店家的 hh:mm、沒有單一時區可寫，
     *   這種情況不帶此參數，既有時區保持不變
     */
    const setSettlement = (settlementTime: string, zoneId?: string) => {
      settlement.value = settlementTime
      if (zoneId) timeZoneId.value = zoneId
    }

    return {
      settlement,
      timeZoneId,
      getSettlement,
      getSettlementTimeZone,
      setSettlement
    }
  },
  {
    persist: {
      storage: localStorage
    }
  }
)
